import I18n from 'I18n';
import { compose } from '../utils/iterables';
import { EmailSubscriptionHublVariables, EmailSubscriptionLinkOptions, ExtraHublVariablesLinkOptions, i18nKey } from '../constants/link';
export const HUBL_VAR_REGEXP = /^{{\s*([a-zA-Z0-9_.]+)\s*}}$/;
export const hasHublVariable = str => /{{.*}}/.test(str);
export const getHublVariable = str => {
  if (typeof str !== 'string') {
    return null;
  }
  const matches = str.trim().match(HUBL_VAR_REGEXP);
  if (matches) {
    return matches[1];
  }
  return null;
};
export const getEmailSystemHublVar = str => {
  const hublVar = getHublVariable(str);
  if (Object.values(EmailSubscriptionHublVariables).includes(hublVar)) {
    return hublVar;
  }
  return null;
};
const getEmailVariableLabel = name => {
  const option = EmailSubscriptionLinkOptions[name];
  return option ? I18n.text(i18nKey(option.text)) : name;
};
export const getEmailSubscriptionLinkDisplayName = compose(getEmailVariableLabel, getEmailSystemHublVar);
export const getLinkCopyDataByHublVar = str => {
  const hublVar = getHublVariable(str);
  return hublVar ? ExtraHublVariablesLinkOptions[hublVar] : null;
};